export class Preference {
    value: string
}



// WEBPACK FOOTER //
// ./src/types/Preference.ts